// src/services/CountryService.js
import api from "./api";

export function getBlogByCountry(page = 1, limit = 5, country_id = null) {
  return api.get(
    `/blog/bycountry?page=${page}&limit=${limit}&countryId=${country_id}`
  );
}

export function getBlogById(id) {
  return api.get(
    `/blog/${id}`
  );
}
